/**
 * Node-type → base-type table, derived from Godot 4.6.3.stable.fedora.7d41c59c4's ClassDB.
 * AUTO-GENERATED - Do not edit manually. Run: pnpm nodes:base-types
 *
 * One entry per hop of every catalogued node's ancestry, so abstract classes
 * that no scene can instantiate still appear as somebody's base. `Node` is the
 * terminal and has no entry. Merged with the hand-written exceptions in
 * nodeBaseTypes.ts, which is what every domain imports.
 */
export const CATALOG_BASE_TYPES = Object.freeze({
    AcceptDialog: 'Window',
    AimModifier3D: 'BoneConstraint3D',
    AnimatableBody2D: 'StaticBody2D',
    AnimatableBody3D: 'StaticBody3D',
    AnimatedSprite2D: 'Node2D',
    AnimatedSprite3D: 'SpriteBase3D',
    AnimationMixer: 'Node',
    AnimationPlayer: 'AnimationMixer',
    AnimationTree: 'AnimationMixer',
    Area2D: 'CollisionObject2D',
    Area3D: 'CollisionObject3D',
    AspectRatioContainer: 'Container',
    AudioListener2D: 'Node2D',
    AudioListener3D: 'Node3D',
    AudioStreamPlayer: 'Node',
    AudioStreamPlayer2D: 'Node2D',
    AudioStreamPlayer3D: 'Node3D',
    BackBufferCopy: 'Node2D',
    BaseButton: 'Control',
    Bone2D: 'Node2D',
    BoneAttachment3D: 'Node3D',
    BoneConstraint3D: 'SkeletonModifier3D',
    BoneTwistDisperser3D: 'SkeletonModifier3D',
    BoxContainer: 'Container',
    Button: 'BaseButton',
    Camera2D: 'Node2D',
    Camera3D: 'Node3D',
    CanvasGroup: 'Node2D',
    CanvasItem: 'Node',
    CanvasLayer: 'Node',
    CanvasModulate: 'Node2D',
    CCDIK3D: 'IterateIK3D',
    CenterContainer: 'Container',
    ChainIK3D: 'IKModifier3D',
    CharacterBody2D: 'PhysicsBody2D',
    CharacterBody3D: 'PhysicsBody3D',
    CheckBox: 'Button',
    CheckButton: 'Button',
    CodeEdit: 'TextEdit',
    CollisionObject2D: 'Node2D',
    CollisionObject3D: 'Node3D',
    CollisionPolygon2D: 'Node2D',
    CollisionPolygon3D: 'Node3D',
    CollisionShape2D: 'Node2D',
    CollisionShape3D: 'Node3D',
    ColorPicker: 'VBoxContainer',
    ColorPickerButton: 'Button',
    ColorRect: 'Control',
    ConeTwistJoint3D: 'Joint3D',
    ConfirmationDialog: 'AcceptDialog',
    Container: 'Control',
    Control: 'CanvasItem',
    ConvertTransformModifier3D: 'BoneConstraint3D',
    CopyTransformModifier3D: 'BoneConstraint3D',
    CPUParticles2D: 'Node2D',
    CPUParticles3D: 'GeometryInstance3D',
    CSGBox3D: 'CSGPrimitive3D',
    CSGCombiner3D: 'CSGShape3D',
    CSGCylinder3D: 'CSGPrimitive3D',
    CSGMesh3D: 'CSGPrimitive3D',
    CSGPolygon3D: 'CSGPrimitive3D',
    CSGPrimitive3D: 'CSGShape3D',
    CSGShape3D: 'GeometryInstance3D',
    CSGSphere3D: 'CSGPrimitive3D',
    CSGTorus3D: 'CSGPrimitive3D',
    DampedSpringJoint2D: 'Joint2D',
    Decal: 'VisualInstance3D',
    DirectionalLight2D: 'Light2D',
    DirectionalLight3D: 'Light3D',
    FABRIK3D: 'IterateIK3D',
    FileDialog: 'ConfirmationDialog',
    FlowContainer: 'Container',
    FogVolume: 'VisualInstance3D',
    FoldableContainer: 'Container',
    Generic6DOFJoint3D: 'Joint3D',
    GeometryInstance3D: 'VisualInstance3D',
    GPUParticles2D: 'Node2D',
    GPUParticles3D: 'GeometryInstance3D',
    GPUParticlesAttractor3D: 'VisualInstance3D',
    GPUParticlesAttractorBox3D: 'GPUParticlesAttractor3D',
    GPUParticlesAttractorSphere3D: 'GPUParticlesAttractor3D',
    GPUParticlesAttractorVectorField3D: 'GPUParticlesAttractor3D',
    GPUParticlesCollision3D: 'VisualInstance3D',
    GPUParticlesCollisionBox3D: 'GPUParticlesCollision3D',
    GPUParticlesCollisionHeightField3D: 'GPUParticlesCollision3D',
    GPUParticlesCollisionSDF3D: 'GPUParticlesCollision3D',
    GPUParticlesCollisionSphere3D: 'GPUParticlesCollision3D',
    GraphEdit: 'Control',
    GraphElement: 'Container',
    GraphFrame: 'GraphElement',
    GraphNode: 'GraphElement',
    GridContainer: 'Container',
    GridMap: 'Node3D',
    GrooveJoint2D: 'Joint2D',
    HBoxContainer: 'BoxContainer',
    HFlowContainer: 'FlowContainer',
    HingeJoint3D: 'Joint3D',
    HScrollBar: 'ScrollBar',
    HSeparator: 'Separator',
    HSlider: 'Slider',
    HSplitContainer: 'SplitContainer',
    HTTPRequest: 'Node',
    IKModifier3D: 'SkeletonModifier3D',
    ImporterMeshInstance3D: 'Node3D',
    ItemList: 'Control',
    IterateIK3D: 'ChainIK3D',
    JacobianIK3D: 'IterateIK3D',
    Joint2D: 'Node2D',
    Joint3D: 'Node3D',
    Label: 'Control',
    Label3D: 'GeometryInstance3D',
    Light2D: 'Node2D',
    Light3D: 'VisualInstance3D',
    LightmapGI: 'VisualInstance3D',
    LightmapProbe: 'Node3D',
    LightOccluder2D: 'Node2D',
    LimitAngularVelocityModifier3D: 'SkeletonModifier3D',
    Line2D: 'Node2D',
    LineEdit: 'Control',
    LinkButton: 'BaseButton',
    LookAtModifier3D: 'SkeletonModifier3D',
    MarginContainer: 'Container',
    Marker2D: 'Node2D',
    Marker3D: 'Node3D',
    MenuBar: 'Control',
    MenuButton: 'Button',
    MeshInstance2D: 'Node2D',
    MeshInstance3D: 'GeometryInstance3D',
    ModifierBoneTarget3D: 'SkeletonModifier3D',
    MultiMeshInstance2D: 'Node2D',
    MultiMeshInstance3D: 'GeometryInstance3D',
    MultiplayerSpawner: 'Node',
    MultiplayerSynchronizer: 'Node',
    NavigationAgent2D: 'Node',
    NavigationAgent3D: 'Node',
    NavigationLink2D: 'Node2D',
    NavigationLink3D: 'Node3D',
    NavigationObstacle2D: 'Node2D',
    NavigationObstacle3D: 'Node3D',
    NavigationRegion2D: 'Node2D',
    NavigationRegion3D: 'Node3D',
    NinePatchRect: 'Control',
    Node2D: 'CanvasItem',
    Node3D: 'Node',
    OccluderInstance3D: 'VisualInstance3D',
    OmniLight3D: 'Light3D',
    OpenXRBindingModifierEditor: 'PanelContainer',
    OpenXRCompositionLayer: 'Node3D',
    OpenXRCompositionLayerCylinder: 'OpenXRCompositionLayer',
    OpenXRCompositionLayerEquirect: 'OpenXRCompositionLayer',
    OpenXRCompositionLayerQuad: 'OpenXRCompositionLayer',
    OpenXRHand: 'Node3D',
    OpenXRInteractionProfileEditor: 'OpenXRInteractionProfileEditorBase',
    OpenXRInteractionProfileEditorBase: 'HBoxContainer',
    OpenXRRenderModel: 'Node3D',
    OpenXRRenderModelManager: 'Node3D',
    OpenXRVisibilityMask: 'VisualInstance3D',
    OptionButton: 'Button',
    Panel: 'Control',
    PanelContainer: 'Container',
    Parallax2D: 'Node2D',
    ParallaxBackground: 'CanvasLayer',
    ParallaxLayer: 'Node2D',
    Path2D: 'Node2D',
    Path3D: 'Node3D',
    PathFollow2D: 'Node2D',
    PathFollow3D: 'Node3D',
    PhysicalBone2D: 'RigidBody2D',
    PhysicalBone3D: 'PhysicsBody3D',
    PhysicalBoneSimulator3D: 'SkeletonModifier3D',
    PhysicsBody2D: 'CollisionObject2D',
    PhysicsBody3D: 'CollisionObject3D',
    PinJoint2D: 'Joint2D',
    PinJoint3D: 'Joint3D',
    PointLight2D: 'Light2D',
    Polygon2D: 'Node2D',
    Popup: 'Window',
    PopupMenu: 'Popup',
    PopupPanel: 'Popup',
    ProgressBar: 'Range',
    Range: 'Control',
    RayCast2D: 'Node2D',
    RayCast3D: 'Node3D',
    ReferenceRect: 'Control',
    ReflectionProbe: 'VisualInstance3D',
    RemoteTransform2D: 'Node2D',
    RemoteTransform3D: 'Node3D',
    ResourcePreloader: 'Node',
    RetargetModifier3D: 'SkeletonModifier3D',
    RichTextLabel: 'Control',
    RigidBody2D: 'PhysicsBody2D',
    RigidBody3D: 'PhysicsBody3D',
    RootMotionView: 'VisualInstance3D',
    ScriptCreateDialog: 'ConfirmationDialog',
    ScrollBar: 'Range',
    ScrollContainer: 'Container',
    Separator: 'Control',
    ShaderGlobalsOverride: 'Node',
    ShapeCast2D: 'Node2D',
    ShapeCast3D: 'Node3D',
    Skeleton2D: 'Node2D',
    Skeleton3D: 'Node3D',
    SkeletonIK3D: 'SkeletonModifier3D',
    SkeletonModifier3D: 'Node3D',
    Slider: 'Range',
    SliderJoint3D: 'Joint3D',
    SoftBody3D: 'MeshInstance3D',
    SpinBox: 'Range',
    SplineIK3D: 'ChainIK3D',
    SplitContainer: 'Container',
    SpotLight3D: 'Light3D',
    SpringArm3D: 'Node3D',
    SpringBoneCollision3D: 'Node3D',
    SpringBoneCollisionCapsule3D: 'SpringBoneCollision3D',
    SpringBoneCollisionPlane3D: 'SpringBoneCollision3D',
    SpringBoneCollisionSphere3D: 'SpringBoneCollision3D',
    SpringBoneSimulator3D: 'SkeletonModifier3D',
    Sprite2D: 'Node2D',
    Sprite3D: 'SpriteBase3D',
    SpriteBase3D: 'GeometryInstance3D',
    StaticBody2D: 'PhysicsBody2D',
    StaticBody3D: 'PhysicsBody3D',
    StatusIndicator: 'Node',
    SubViewport: 'Viewport',
    SubViewportContainer: 'Container',
    TabBar: 'Control',
    TabContainer: 'Container',
    TextEdit: 'Control',
    TextureButton: 'BaseButton',
    TextureProgressBar: 'Range',
    TextureRect: 'Control',
    TileMap: 'Node2D',
    TileMapLayer: 'Node2D',
    Timer: 'Node',
    TouchScreenButton: 'Node2D',
    Tree: 'Control',
    TwoBoneIK3D: 'IKModifier3D',
    VBoxContainer: 'BoxContainer',
    VehicleBody3D: 'RigidBody3D',
    VehicleWheel3D: 'Node3D',
    VFlowContainer: 'FlowContainer',
    VideoStreamPlayer: 'Control',
    Viewport: 'Node',
    VisibleOnScreenEnabler2D: 'VisibleOnScreenNotifier2D',
    VisibleOnScreenEnabler3D: 'VisibleOnScreenNotifier3D',
    VisibleOnScreenNotifier2D: 'Node2D',
    VisibleOnScreenNotifier3D: 'VisualInstance3D',
    VisualInstance3D: 'Node3D',
    VoxelGI: 'VisualInstance3D',
    VScrollBar: 'ScrollBar',
    VSeparator: 'Separator',
    VSlider: 'Slider',
    VSplitContainer: 'SplitContainer',
    Window: 'Viewport',
    WorldEnvironment: 'Node',
    XRAnchor3D: 'XRNode3D',
    XRBodyModifier3D: 'SkeletonModifier3D',
    XRCamera3D: 'Camera3D',
    XRController3D: 'XRNode3D',
    XRFaceModifier3D: 'Node3D',
    XRHandModifier3D: 'SkeletonModifier3D',
    XRNode3D: 'Node3D',
    XROrigin3D: 'Node3D',
});
//# sourceMappingURL=nodeBaseTypes.generated.js.map